export default class ServersidePaging {
    totalCount = 0;
    pageNumber = 1;
    pageSize = 10;
    pageSizeOptions = [10, 20, 50, 100];
    
    reset() {
        this.totalCount = 0;
        this.pageNumber = 1;
        this.pageSize = 10;
    }
}